import { Heading } from "@/common/components";
import { formatPhoneNumber } from "@/utils/Utilities";

const ViewContactInformation = ({
  contactInfo,
  labels,
  wrapperClassName,
  section1ClassName,
  section2ClassName,
  section3ClassName,
}) => {
  return (
    <>
      <Heading
        text={labels?.contactInformation}
        wrapperClassNames="h4 border-bottom-1 pb-2 mb-0"
        title={false}
      />
      <section className={wrapperClassName}>
        <section className={section1ClassName}>
          <div className="division">
            <span className="left">Name</span>
            <span className="right">
              {contactInfo?.firstName} {contactInfo?.middleName}{" "}
              {contactInfo?.lastName}
            </span>
          </div>

          <div className="division">
            <span className="left">Address 1</span>
            <span className="right">{contactInfo?.addressLine1}</span>
          </div>

          <div className="division">
            <span className="left">Address 2</span>
            <span className="right">{contactInfo?.addressLine2 || "-"}</span>
          </div>

          <div className="division">
            <span className="left">Address 3</span>
            <span className="right">{contactInfo?.addressLine3 || "-"}</span>
          </div>
        </section>

        <section className={section2ClassName}>
          <div className="division">
            <span className="left">City</span>
            <span className="right">{contactInfo?.cityName || "-"}</span>
          </div>

          <div className="division">
            <span className="left">State</span>
            <span className="right">{contactInfo?.stateCountry || "-"}</span>
          </div>

          <div className="division">
            <span className="left">Zip</span>
            <span className="right">{contactInfo?.zip}</span>
          </div>

          <div className="division">
            <span className="left">{labels?.phone}</span>
            <span className="right">
              {formatPhoneNumber(contactInfo?.phoneNumber)}
            </span>
          </div>
        </section>

        <section className={section3ClassName}>
          <div className="division">
            <span className="left">{labels?.ext}</span>
            <span className="right">{contactInfo?.phoneExtension || "-"}</span>
          </div>

          <div className="division">
            <span className="left">{labels?.cellPhone}</span>
            <span className="right">
              {formatPhoneNumber(contactInfo?.cellPhoneNumber) || "-"}
            </span>
          </div>

          <div className="division">
            <span className="left">{labels?.fax}</span>
            <span className="right">
              {formatPhoneNumber(contactInfo?.faxPhoneNumber) || "-"}
            </span>
          </div>
          <div className="division">
            <span className="left">Email</span>
            <span className="right">{contactInfo?.emailAddress}</span>
          </div>
        </section>
      </section>
    </>
  );
};

export default ViewContactInformation;
